<template>
	<div class="page metric-calculation">
		<section id="navigation">
			<div class="container">
				<div class="content flex">
					<span @click="$router.go(-1);" class="go-back"><svg class="navigation-icon link-icon small" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 20"><path d="M.8 10L10.36.44 13.2 3.3 6.5 10l6.72 6.7-2.85 2.85L.8 10z"/></svg></span>
					<svg class="navigation-icon left" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65 100"><path d="M32.5 100C14.58 100 0 85.2 0 67s14.58-33 32.5-33a32.14 32.14 0 0 1 5.63.49V0H65v66.26q0 .4 0 .77C65 85.2 50.42 100 32.5 100zm0-61.94C16.8 38.06 4 51.06 4 67s12.8 29 28.5 29S61 83 61 67 48.2 38.06 32.5 38.06zm9.63-2.52A32.77 32.77 0 0 1 61 51.2V36.52h-7.15v-4H61v-3.75H47v-4h14V21h-7.15v-4H61v-3.7H47v-4h14V4H42.13zM32.5 93a26 26 0 0 1 0-52 26 26 0 0 1 0 52zm0-48a22 22 0 0 0 0 44 22 22 0 0 0 0-44zm0 41a19 19 0 1 1 18.77-19A18.93 18.93 0 0 1 32.5 86.06zm0-34a15 15 0 1 0 14.77 15A14.92 14.92 0 0 0 32.5 52z"/><path d="M27.16 63.58a2 2 0 0 1-2-2v-3.06c0-7.7 6.3-9.74 9.62-9.74h2.73a2 2 0 0 1 0 4H34.8a5.39 5.39 0 0 0-5.62 5.74v3.07a2 2 0 0 1-2.01 1.99z"/></svg>
					<span class="navigation-title">{{$t('calculations')}}</span>
				</div>
			</div>
		</section>
		<transition name="slide-up" mode="out-in" appear>
			<section class="main no-padding-top" :key="$route.params.id">
				<div class="list">
					<router-link
						v-for="(link, index) in links"
						:key="'link-' + index"
						class="list-link"
						:to="link.to"
					>
						<div class="container">
							<div class="content">
								<div class="list-link-inner">
									{{link.title}}
									<svg class="list-link-icon link-icon arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 20"><path d="M.8 10L10.36.44 13.2 3.3 6.5 10l6.72 6.7-2.85 2.85L.8 10z"/></svg>
								</div>
							</div>
						</div>
					</router-link>
				</div>
			</section>
		</transition>
	</div>
</template>

<script>

export default {
	data() {
		return {
			links: [
				{to: {name: 'calculate-twists'}, title: this.$t('calculate-twists')},
				{to: {name: 'measure-yarn-count'}, title: this.$t('measure-yarn-count')},
				{to: {name: 'needles-heads'}, title: this.$t('needles-heads')},
				{to: {name: 'calculate-production-kgh'}, title: this.$t('calculate-production-kgh')},
				{to: {name: 'calculate-roving-bobbins-steering'}, title: this.$t('calculate-roving-bobbins-steering')}
			]
		}
	}
}	
</script>

<style scoped>
</style>